// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__2b54h","icon":"Notification_icon__kfWFP","cta":"Notification_cta__3CPGk"};